import { DeliveryStats } from "@pulse/pulse-rpcs/lib/email-cycle/deliveryStats";
import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const DeliveryStatsModel = types
  .model("DeliveryStatsModel", {
    total: types.integer,
    queued: types.integer,
    sent: types.integer,
    delivered: types.integer,
    viewed: types.integer,
    unsent: types.integer,
    optOut: types.integer,
    bounces: types.integer,
    complaints: types.integer,
  })
  .actions((store) => ({
    setStats: (stats: DeliveryStats): void => {
      store.total = stats.total;
      store.queued = stats.queued;
      store.sent = stats.sent;
      store.delivered = stats.delivered;
      store.viewed = stats.viewed;
      store.unsent = stats.unsent;
      store.optOut = stats.optOut;
      store.bounces = stats.bounces;
      store.complaints = stats.complaints;
    },
  }));

export const createDeliveryStatsModel = (
  deliveryStats?: SnapshotIn<typeof DeliveryStatsModel>,
): Instance<typeof DeliveryStatsModel> =>
  DeliveryStatsModel.create(
    deliveryStats ?? {
      total: 0,
      queued: 0,
      sent: 0,
      delivered: 0,
      viewed: 0,
      unsent: 0,
      optOut: 0,
      bounces: 0,
      complaints: 0,
    },
  );
